export default "__VITE_ASSET__4271e7c6__"